export default __webpack_public_path__ + "static/media/gallery_08.08cf3ca3.jpg";